var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"material-icons"},[_vm._v("table_chart")])
}
var staticRenderFns = []

export { render, staticRenderFns }